var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/recharts/~/core-js/modules/_has.js
 ** module id = 1993
 ** module chunks = 3
 **/